import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { useSelector } from "react-redux";

export function Brand() {
  const uiService = useHtmlClassService();
  const { user } = useSelector(state => state.auth);

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo(),
    };
  }, [uiService]);

  return (
    <>
      <>
        <div className="offcanvas-content pr-5 mr-n5 mt-5 ml-4">
          <div className="d-flex align-items-center mt-5">
            <div className="symbol symbol-100 mr-5">
              <div className="symbol-label">POS</div>
            </div>
            <div className="d-flex flex-column">
              <p
                
                className="font-weight-bold font-size-h8  text-light"
              >
                {/* admin demo */}
                {user.data.email}
              </p>
              {/* <div className="text-muted mt-1">Application Developer</div> */}
              <div className="navi mt-2">
                <a href="#" className="navi-item">
                  <span className="navi-link p-0 pb-2"></span>
                </a>
              </div>
            </div>
          </div>

          {/*<div className="separator separator-dashed mt-8 mb-5" />*/}
        </div>
        {/* begin::Toggle */}
        {/*<button
              className="brand-toggle btn btn-sm px-0"
              id="kt_aside_toggle"
            >
              <span className="svg-icon svg-icon-xl">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Navigation/Angle-double-left.svg"
                  )}
                />
              </span>
            </button>*/}
        {/* end::Toolbar */}
      </>
    </>
  );
}
